/**
 * Runtime configuration provider.
 *
 * Derives GATEWAY_URL and CLIENT_URL from the current window location
 * so a single build can be deployed to any environment.
 *
 * Convention:
 *   - <subdomain>.juristic.io  →  API at <subdomain>-api.juristic.io
 *   - CLIENT_URL is the current origin (where the add-in is served)
 *   - localhost falls back to local dev defaults
 */ import { env } from "@Config/env";
function getGatewayUrl() {
    const { hostname, protocol } = window.location;
    // Local development
    if ([
        "localhost",
        "127.0.0.1",
        "0.0.0.0"
    ].includes(hostname)) {
        return env.GATEWAY_URL;
    }
    // e.g. elastic.juristic.io → elastic-api.juristic.io
    return `${protocol}//${hostname.replace("-word-plugin", "-api")}`;
}
function getClientUrl() {
    return window.location.origin;
}
export const runtime = {
    gatewayUrl: getGatewayUrl(),
    clientUrl: getClientUrl()
};
